<template>
  <div id="login">
    <section>
      <div class="container">
        <div class="row pb-3">
          <div
            class="col-12 text-center"
            data-aos="fede-up"
            data-aos-delay="200"
          >
            <img
              class="img-fluid pt-4"
              src="../assets/imgs/mrp/mrp-logo.png"
              alt="Mr. P"
            />
          </div>
        </div>

        <form @submit="submitFormulario($event)" class="row">
          <div class="col-12 text-center fG3 pb-4 lighter">
            Be part of the first edition, nominate a person, team or project by
            category taking into account the characteristics mentioned in each
            one.
          </div>

          <div class="col-12 text-center fG3 py-4">&nbsp;</div>

          <div class="col-12 text-center fG3 pb-2 bold">
            MMVP - Marketing Most Valuable Player
          </div>

          <div class="col-12 text-center fG3 pb-3 lighter">
            K Values refference <br />
            YTD Business Delivery <br />
            Growth competences performance
          </div>

          <div class="col-12 text-center pb-0">
            <label>
              <input
                required
                type="text"
                v-model="signupForm.nominate_1"
                placeholder="I nominate:"
              />
            </label>
          </div>
          <div class="col-12 text-center pb-4">
            <label>
              <textarea
                v-model="signupForm.reason_1"
                id=""
                cols="30"
                rows="3"
                placeholder="Because..."
              ></textarea>
            </label>
          </div>

          <div class="col-12 text-center fG3 py-2">&nbsp;</div>

          <div class="col-12 text-center fG3 pb-2 bold">Best Innovation</div>

          <div class="col-12 text-center fG3 pb-3 lighter">
            NS Performance <br />
            Creativity <br />
            Impact
          </div>

          <div class="col-12 text-center pb-0">
            <label>
              <input
                required
                type="text"
                v-model="signupForm.nominate_2"
                placeholder="I nominate:"
              />
            </label>
          </div>
          <div class="col-12 text-center pb-4">
            <label>
              <textarea
                v-model="signupForm.reason_2"
                id=""
                cols="30"
                rows="3"
                placeholder="Because..."
              ></textarea>
            </label>
          </div>

          <div class="col-12 text-center fG3 py-2">&nbsp;</div>

          <div class="col-12 text-center fG3 pb-2 bold">
            Best Brand Performance
          </div>

          <div class="col-12 text-center fG3 pb-3 lighter">
            SoM Growth <br />
            P&L Delivery <br />
            Quality Execution
          </div>

          <div class="col-12 text-center pb-0">
            <label>
              <input
                required
                type="text"
                v-model="signupForm.nominate_3"
                placeholder="I nominate:"
              />
            </label>
          </div>
          <div class="col-12 text-center pb-4">
            <label>
              <textarea
                v-model="signupForm.reason_3"
                id=""
                cols="30"
                rows="3"
                placeholder="Because..."
              ></textarea>
            </label>
          </div>

          <div class="col-12 text-center fG3 py-2">&nbsp;</div>

          <div class="col-12 text-center fG3 pb-2 bold">
            Best Commercial Program Execution
          </div>

          <div class="col-12 text-center fG3 pb-3 lighter">
            Creativity <br />
            Impact <br />
            Expansion potential
          </div>

          <div class="col-12 text-center pb-0">
            <label>
              <input
                required
                type="text"
                v-model="signupForm.nominate_4"
                placeholder="I nominate:"
              />
            </label>
          </div>
          <div class="col-12 text-center pb-4">
            <label>
              <textarea
                v-model="signupForm.reason_4"
                id=""
                cols="30"
                rows="3"
                placeholder="Because..."
              ></textarea>
            </label>
          </div>

          <div class="col-12 text-center fG3 py-2">&nbsp;</div>

          <div class="col-12 text-center fG3 pb-2 bold">
            Young MKT Professional
          </div>

          <div class="col-12 text-center fG3 pb-3 lighter">
            K Values refference <br />
            YTD delivery
          </div>

          <div class="col-12 text-center pb-0">
            <label>
              <input
                required
                type="text"
                v-model="signupForm.nominate_5"
                placeholder="I nominate:"
              />
            </label>
          </div>
          <div class="col-12 text-center pb-4">
            <label>
              <textarea
                v-model="signupForm.reason_5"
                id=""
                cols="30"
                rows="3"
                placeholder="Because..."
              ></textarea>
            </label>
          </div>

          <div class="col-12 text-center fG3 py-2">&nbsp;</div>

          <div class="col-12 text-center pb-4">
            <button type="submit" class="btnblanco fXG">Send</button>
          </div>

          <div class="col-12 text-center fG3 py-2">
            <p class="lighter fG3 gris">Send before 29th September</p>
          </div>
        </form>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>

    
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    //Footer,
    //SiteNav,
  },
  data() {
    return {
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nominate_1: "",
        reason_1: "",
        type_1: "MMVP - Marketing Most Valuable Player",
        nominate_2: "",
        reason_2: "",
        type_2: "Best Innovation",
        nominate_3: "",
        reason_3: "",
        type_3: "Best Brand Performance",
        nominate_4: "",
        reason_4: "",
        type_4: "Best Commercial Program Execution",
        nominate_5: "",
        reason_5: "",
        type_5: "Young MKT Professional",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      guia: false,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    console.log({ id: this.id });

    if (this.id != undefined) {
      this.traeDatos();
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    traeDatos() {
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        codigo: this.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "datos-iniciales.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.preForm.codigo = res.datos[0].codigo;
              this.preForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.preForm.email = res.datos[0].email;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    submitFormulario(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              //this.toggleOverlay();

              swal.fire("Vote received", "", "success");

              this.$store.dispatch("showLoader", false);

              this.signupForm = {
                nominate_1: "",
                reason_1: "",
                type_1: "MMVP - Marketing Most Valuable Player",
                nominate_2: "",
                reason_2: "",
                type_2: "Best Innovation",
                nominate_3: "",
                reason_3: "",
                type_3: "Best Brand Performance",
                nominate_4: "",
                reason_4: "",
                type_4: "Best Commercial Program Execution",
                nominate_5: "",
                reason_5: "",
                type_5: "Young MKT Professional",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_zapatos: "",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_zapatos = "";
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.handicap = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
        this.signupForm.talla_zapatos = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      }
    },
    toggleOverlay() {
      this.$store.state.overlay = !this.$store.state.overlay;

      console.log({ click: this.$store.state.overlay });
    },
  },
};
</script>
